import { OtherOffer } from "./OtherOffer";
import { TournamentOffer } from "./TournamentOffer";

export class SportCategoryGroup {
	sportId: string;
	categoryId: string;
	items: TournamentOffer[];
	otherOffers: OtherOffer[];
}